module.exports = __webpack_public_path__ + "static/img/deviceMenu.c8ac1f88.png";